import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

const MAX_DESCRIPCION = 2000;

interface EditarDescripcionEgresoDialogProps {
  open: boolean;
  nroFormulario: number | null;
  comprobanteLabel?: string | null;
  concepto?: string | null;
  descripcionInicial?: string;
  saving?: boolean;
  onClose: () => void;
  onSave: (descripcion: string) => void;
}

const EditarDescripcionEgresoDialog: React.FC<EditarDescripcionEgresoDialogProps> = ({
  open,
  nroFormulario,
  comprobanteLabel,
  concepto,
  descripcionInicial = '',
  saving = false,
  onClose,
  onSave,
}) => {
  const [descripcion, setDescripcion] = useState('');
  const [baseline, setBaseline] = useState('');

  useEffect(() => {
    if (!open) return;
    setDescripcion(descripcionInicial);
    setBaseline(descripcionInicial);
  }, [open, descripcionInicial]);

  const hasChanges = descripcion.trim() !== baseline.trim();

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleSubmit = () => {
    if (!hasChanges || saving) return;
    onSave(descripcion);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Editar descripción</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Egreso #{nroFormulario}
          {comprobanteLabel ? ` · ${comprobanteLabel}` : ''}
          {concepto ? ` · ${concepto}` : ''}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={4}
          autoFocus
          label="Descripción"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value.slice(0, MAX_DESCRIPCION))}
          disabled={saving}
          inputProps={{ maxLength: MAX_DESCRIPCION }}
          helperText={`${descripcion.length}/${MAX_DESCRIPCION}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={saving || !hasChanges}
        >
          {saving ? 'Guardando…' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarDescripcionEgresoDialog;
